var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "editor" } }, [
    _vm.loading
      ? _c("div", [_vm._v("Loading...")])
      : _c("div", [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(
                _vm.website == null ? "" : _vm.website.htmlContent
              ),
            },
          }),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }